export enum TabKey {
  General = 'general',
  Teacher = 'teacher',
  Tutor = 'tutor',
  Content = 'content'
}
